import { render } from "./Cocktails.vue?vue&type=template&id=91a115f4&scoped=true"
import script from "./Cocktails.vue?vue&type=script&lang=js"
export * from "./Cocktails.vue?vue&type=script&lang=js"

import "./Cocktails.vue?vue&type=style&index=0&id=91a115f4&scoped=true&lang=css"

import exportComponent from "/Users/ward/Projects/Chelsea/sherryV2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a115f4"]])

export default __exports__